/**Map para correlacionar colores de fondo de pantalla de carga con url de institucion*/
/**Se utiliza un map de key/value para rastrear de manera rápida la url 
 * y devolver el slug correspondiente para utilizar en la landing */
 export const mapBg = new Map<string, string>();
 mapBg.set( "localhost:4200", "#0d1f43"); 
 mapBg.set("espaciomo.ar",'#D4BD9D');
 mapBg.set("www.espaciomo.ar",'#D4BD9D');
 mapBg.set("asocespaniola.com.ar",'#c2c0c0');
 mapBg.set("amesalud.ar",'#c2c0c0');
 mapBg.set("ilanding.red-i.com.ar","#0d1f43");
 mapBg.set("idemo.red-i.com.ar","#0d1f43");
 mapBg.set("idev.red-i.kozaca.com.ar",'#0d1f43');
 mapBg.set("romamedicinaestetica.com.ar",'#d4bd9d');
 mapBg.set("www.romamedicinaestetica.com.ar",'#d4bd9d');